import { z } from 'zod';
import { ConnectorKind } from './kind.js';
/**
 * The connector-runtime contract event envelope. Every adapter's
 * webhook/ingest path normalizes its vendor-specific payload into
 * this shape before handing off to the graph-ingest layer. The
 * normalization is what makes adding a 6th connector a few-day job
 * (per the issue's framework goal).
 *
 * `kind` identifies the source connector; `payload` is the
 * connector-specific normalized record (e.g. `{messageId, channel,
 * authorHandle, text, postedAt}` for Slack messages, `{prNumber,
 * authorLogin, repo, state}` for GitHub PRs). Adapters are
 * responsible for shaping the payload — the graph-ingest layer reads
 * it via a per-kind mapper.
 */
export const ConnectorEvent = z.object({
    kind: ConnectorKind,
    /** Per-org scope — used by graph-ingest to set the orgId on every node. */
    orgId: z.string().min(1),
    /** Vendor's own event id (Slack event_id, GitHub delivery id, Stripe event.id). */
    eventId: z.string().min(1),
    /** The vendor's own event type (e.g. 'message.channels', 'pull_request'). */
    eventType: z.string().min(1),
    /** Normalized payload — adapter-specific shape. */
    payload: z.unknown(),
    /** Vendor timestamp; falls back to receipt time when absent. */
    occurredAt: z.string(),
    /** Receipt time at the webhook receiver. */
    receivedAt: z.string(),
});
/** Outcome of a single event-handle call — drives the per-event audit row. */
export const CONNECTOR_HANDLE_OUTCOMES = [
    'ingested',
    'skipped',
    'dryrun',
    'failed',
];
export const ConnectorHandleOutcome = z.enum(CONNECTOR_HANDLE_OUTCOMES);
